
export default function EventHero() {
  return (
    <section className="relative pt-32 pb-20 px-4 overflow-hidden">
      {/* Striped Background */}
      <div className="absolute inset-0 flex">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className={`flex-1 ${i % 2 === 0 ? 'bg-[#FFD700]' : 'bg-white'}`}
          />
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/5 to-transparent"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-[#2C5F2D]/10 rounded-full px-5 py-2 mb-6">
          <i className="ri-camera-line w-5 h-5 flex items-center justify-center text-[#2C5F2D]"></i>
          <span className="text-sm font-semibold text-[#2C5F2D]">Capturing Our Best Moments</span>
        </div>
        <h1
          className="text-5xl md:text-6xl font-bold text-[#2C5F2D] mb-6"
          style={{ fontFamily: "Georgia, serif" }}
        >
          Event Gallery
        </h1>
        <p className="text-xl text-[#4A4A4A] max-w-2xl mx-auto leading-relaxed">
          Browse through our favorite moments from weddings, corporate events, community
          gatherings, and workshops we&apos;ve had the pleasure of catering.
        </p>
      </div>
    </section>
  );
}
